import { AntSelectPropsGeneric, AntSelectValue } from 'controls/react/ant/ant-select/types';
import { BaseOptionType } from '@rc-component/select/lib/Select';
import React from 'react';
import { CustomTagProps } from '@rc-component/select/lib/BaseSelect';
import { EditableTag } from 'controls/react/ant/ant-select/components/editable-tag/editableTag';

export function useEditableTagRender<VT extends AntSelectValue, OptionType extends BaseOptionType>(
	props: AntSelectPropsGeneric<VT, OptionType>,
) {
	const { tagRender, editable, onLabelEdit, getOptionExtra, ...rest } = props;

	const tagRenderForEditableTags = React.useCallback(
		(item: CustomTagProps) => {
			const element = props.options.find((element) => element.value === item.value);
			const extra = getOptionExtra?.(element) ?? {};
			return (
				<EditableTag
					{...item}
					editable={props.disabled ? false : editable !== false && (extra?.editable ?? false) && onLabelEdit != null}
					removable={props.disabled ? false : (extra?.removable ?? true)}
					tooltip={extra?.tooltip ?? ''}
					extra={extra}
					nonRemovableMessage={extra?.nonRemovableMessage}
					onLabelEdit={onLabelEdit}
				/>
			);
		},
		[props.options],
	);

	return {
		tagRender: props.mode == 'tags' && tagRender == null ? tagRenderForEditableTags : tagRender,
		...rest,
	};
}
